module.exports = __webpack_public_path__ + "static/media/cheryl-cole-lesb.499151d8.jpg";